<script>
    import {onMount} from 'svelte';
    import {db,data} from "../store";
    import {push} from "svelte-spa-router";
    import {fade} from 'svelte/transition';
    
	let c;
    let ctx,canvas;
	let coord = {x:0,y:0};
	let paint = false;

    onMount(()=>{
        if ($data.local == undefined || $data.local == ""){
            push('/');
        }
		ctx = canvas.getContext("2d");
		canvas.width = 350;
		canvas.height = 350;
    })
    function limpiar(){
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    function getPosition(event){
		let cx =
			event.touches != undefined
			? event.touches[0].clientX
			: event.clientX;
		let cy =
			event.touches != undefined
			? event.touches[0].clientY
			: event.clientY;
		coord.x = cx - getOffsetLeft(canvas);
		coord.y = cy - getOffsetTop(canvas);
	}
		function getOffsetLeft( elem ){
    	var offsetLeft = 0;
    	do {
      	if ( !isNaN( elem.offsetLeft ) )
      	{
         	 offsetLeft += elem.offsetLeft;
      	}
    	} while( elem = elem.offsetParent );
    	return offsetLeft;
	}
	function getOffsetTop( elem ){
    	var offsetTop = 0;
    	do {
      	if ( !isNaN( elem.offsetTop ) )
      	{
         	 offsetTop += elem.offsetTop;
      	}
    	} while( elem = elem.offsetParent );
    	return offsetTop;
	}
	function startPainting(event){
		paint = true;
		getPosition(event);
	}
	function stopPainting(){
		$data.firma = canvas.toDataURL();
		paint = false;
	}
	function sketch(event){
		if (!paint) return;
		ctx.beginPath();
		ctx.lineWidth = 2;
		ctx.lineCap = "round";
		ctx.strokeStyle = "black";
		ctx.moveTo(coord.x, coord.y);
		getPosition(event);
		ctx.lineTo(coord.x,coord.y);
		ctx.stroke();
	}

    async function guardar(){
        let hoy = Date.now();
        let fecha = new Date($data.fecha.ano,$data.fecha.mes-1,$data.fecha.dia).getTime();
        let cliente;
        if ($data.mayor.nombre){
            let fechaMayor = new Date($data.mayor.fecha.ano,$data.mayor.fecha.mes-1,$data.mayor.fecha.dia).getTime();
            cliente = {
                nombre: $data.nombre,
                documento: $data.documento,
                celular:$data.telefono,
                instagram:$data.instagram,
                cumple:fecha,
                cumpleFamiliar:fechaMayor,
                nombreFamiliar:$data.mayor.nombre,
                documentoFamiliar:$data.mayor.documento,
                vinculo:$data.mayor.vinculo,
                fecha: hoy
            }
        } else {
            cliente = {
                nombre: $data.nombre,
				documento: $data.documento,
				celular:$data.telefono,
				instagram:$data.instagram,
				cumple:fecha,
                fecha: hoy
            }
        }
        let doc = cliente;
        doc._id = `cliente:${$data.documento}`;
        doc.documentos = [
        ];
        doc.service = $data.service;
        doc.artista = $data.artista;
        doc.documentos.push({
            nombre: $data.nombre,
            documento: $data.documento,
            celular:$data.telefono,
            fecha: hoy,
            cuerpo:$data.respuestas,
            local: $data.dbLocal,
            idLocal: $data.local,
            abreviacion: $data.url,
            firma:$data.firma
        });

        const userList = {
            C: 'costa',
            SM: 'arteaflordepiel',
            G: 'guemes',
            SF: 'santafe'
        };
        const groupName = {
            C: 'arte',
            G: 'arte',
            SF: 'arte',
            SM: 'arteaflordepiel'
        };
        let parent = null;

        if ($data.mayor.nombre) {
            parent = {
                name: $data.mayor.nombre,
                document: $data.mayor.documento,
                relationship: $data.mayor.vinculo
            };
        }

        const newClient = {
            user: userList[$data.url],
            group: groupName[$data.url],
            name: $data.nombre.trim(),
            document: $data.documento,
            isMenor: $data.mayor.nombre || null,
            type: $data.service === 'Perforación' ? 'perfo' : 'tatoo',
            parent,
            phone: $data.telefono,
            birthday: fecha,
            register: hoy
        };
        var myHeaders = new Headers();

        myHeaders.set('Authorization', 'Basic ' + btoa('arte' + ":" + 'flor'));
        // fetch("https://vps-1858514-x.dattaweb.com/arteflordepiel",{
        //     headers: {
        //     'Content-Type': 'application/json',
        //     'Authorization':'Basic ' + btoa('arte' + ":" + 'flor')
        //     // 'Content-Type': 'application/x-www-form-urlencoded',
        //     },
        //     method: 'POST',
        //     mode:'cors',
        //     //auth:{username:"arte",password:"flor"},
        //     body: JSON.stringify(doc)
        // })
        // .then((res)=>{
        //     console.log(res);
        //     push('/agradecimiento');
        // })
        // .catch((err)=>{
        //     console.log('error');
        //     console.log(err);
        // })
        fetch("https://draco.com.ar/add-client", {
            headers: {
                'Content-Type': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            method: 'POST',
            mode:'cors',
            body: JSON.stringify(newClient)
        })
        .then((res) => {
            console.log(res);
            push('/agradecimiento');
        })
        .catch((err) => {
            console.log('error: ', err);
        });
    }
</script>

<style>
	.noscroll{
		touch-action: none;
	}
</style>


<div class="flex flex-col items-center justify-start w-screen h-screen p-4 noscroll" in:fade="{{duration: 500}}">
    <div class="w-full grid grid-cols-3 grid-row-auto">
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-red-500 shadow text-white rounded-full flex items-center justify-center">1</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">2</div>
        </div>
        <div class="flex items-center justify-center">
            <div class="w-8 h-8 bg-white shadow rounded-full flex items-center justify-center">3</div>
        </div>
    </div>
    <div class="w-full grid grid-cols-3 grid-row-auto text-xs text-center">
        <div class="flex flex-col items-center justify-start">
            Datos Personales
        </div>
        <div class="flex flex-col items-center justify-start">
            Servicio
        </div>
        <div class="flex flex-col items-center justify-start">
            Firma
        </div>
    </div>
    <div class="m-2 p-2 w-full flex items-center justify-center font-bold">
		POR FAVOR FIRME AQUÍ
	</div>
    <button on:click={()=>limpiar()} class="m-2 p-2 bg-red-500 text-white shadow rounded">Limpiar Firma</button>
    <canvas bind:this={canvas} 
	  	on:mousedown={startPainting}
	  	on:touchstart={startPainting}
	  	on:touchmove={sketch}
	 	 on:mousemove={sketch}
	  	on:touchend={stopPainting}
	  	on:mouseup={stopPainting}
		class="noscroll border-2 border-black" id="sheet" width="350" height="350"/>
    <button on:click={()=>guardar()} class="m-2 p-2 bg-red-500 text-white shadow rounded">Finalizar</button>
</div>
